import { render, staticRenderFns } from "./CreateAdicionalModal.vue?vue&type=template&id=d4478a50&scoped=true"
import script from "./CreateAdicionalModal.vue?vue&type=script&lang=js"
export * from "./CreateAdicionalModal.vue?vue&type=script&lang=js"
import style0 from "./CreateAdicionalModal.vue?vue&type=style&index=0&id=d4478a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4478a50",
  null
  
)

export default component.exports